import React, {Component} from 'react';
import {Card, Typography} from '@material-ui/core';
import {Bar} from 'react-chartjs-2';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.secondary,
    height:'100%',
    margin:10
  }
});

class DataTile extends Component {
  render()
  {
    const {classes, data, theme} = this.props;
    const dataWithColors = data.datasets.map(obj => ({
      ...obj,
      borderColor    : theme.palette.secondary.main,
      backgroundColor: theme.palette.secondary.main
    }));
    return (
      <Card className={classNames(classes.root)}>

        <div className="p-16 pb-0 flex flex-row flex-wrap items-end">

          <div className="pr-16">
            <Typography className="h3" color="textSecondary">{this.props.title}</Typography>
            <Typography className="text-56 font-300 leading-none mt-8">
              {data.conversion.value}
            </Typography>
          </div>
        </div>

        {(this.props.showChart !== false) &&
          <div className="h-96 w-100-p">
            <Bar data={{
              labels: data.labels,
              datasets: dataWithColors
            }} options={data.options}/>
          </div>
        }
      </Card>
    );
  }
}


export default withStyles(styles, {withTheme: true})(DataTile);


// WEBPACK FOOTER //
// ./src/main/content/company/components/DataTile.js